import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M7 17.5L12 12L7 6.5M13 17.5L18 12L13 6.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
